import React from 'react'
import {Rect} from "react-konva";

const SnapRectangle = ({
                           shapeProps,
                           layer,
                           stage,
                           blockSnapSize,
                           handleDragMove,
                           handleDragStart,
                           handleDragEnd
                       }) => {
    const shapeRef = React.useRef();
    const trRef = React.useRef();

    return (
        <>

            <Rect
                {...shapeProps}
                draggable
                onDragMove={handleDragMove}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
            />

        </>
    )
}

export default SnapRectangle
